import {
	useCreateRiskIndicatorImpactMutation,
	useUpdateRiskIndicatorImpactStrengthMutation,
	useDeleteRiskIndicatorImpactMutation,
	useCreateStakeIndicatorImpactMutation,
	useUpdateStakeIndicatorImpactStrengthMutation,
	useDeleteStakeIndicatorImpactMutation
} from 'graph/dist/generated';
import { useXImpactController } from './useXImpact';

// Liens Risque<->Indicateur et Enjeu<->Indicateur (avec intensite 1-3).
// Reutilise le controller generique useXImpact : champ `impactedIndicators`
// sur Risk/Stake, methodes create${Origin}IndicatorImpact.
export const useIndicatorImpactController = () => {
	const ctrl = useXImpactController();
	const [createRI] = useCreateRiskIndicatorImpactMutation();
	const [updateRI] = useUpdateRiskIndicatorImpactStrengthMutation();
	const [deleteRI] = useDeleteRiskIndicatorImpactMutation();
	const [createSI] = useCreateStakeIndicatorImpactMutation();
	const [updateSI] = useUpdateStakeIndicatorImpactStrengthMutation();
	const [deleteSI] = useDeleteStakeIndicatorImpactMutation();

	return {
		// Risque <-> Indicateur
		createRiskIndicatorImpact: (riskId: string, indicatorId: string) =>
			ctrl.create(createRI, 'Risk', riskId, 'Indicator', indicatorId),
		updateRiskIndicatorImpactStrength: (impact: any, strength: number) =>
			ctrl.updateStrength(updateRI, impact, 'Risk', 'Indicator', strength),
		deleteRiskIndicatorImpact: (id: string, riskId: string) =>
			ctrl.delete(deleteRI, id, 'Risk', riskId, 'Indicator'),

		// Enjeu <-> Indicateur
		createStakeIndicatorImpact: (stakeId: string, indicatorId: string) =>
			ctrl.create(createSI, 'Stake', stakeId, 'Indicator', indicatorId),
		updateStakeIndicatorImpactStrength: (impact: any, strength: number) =>
			ctrl.updateStrength(updateSI, impact, 'Stake', 'Indicator', strength),
		deleteStakeIndicatorImpact: (id: string, stakeId: string) =>
			ctrl.delete(deleteSI, id, 'Stake', stakeId, 'Indicator')
	};
};
